import MaskInput from './MaskInput';

export { default as formatWithMask } from './formatWithMask';
export { default as createNumberMask } from './createNumberMask';
export { default as Masks } from './Masks';
export { default as useMaskedInputProps } from './useMaskedInputProps';

export type { UseMaskedInputProps } from './useMaskedInputProps.types';
export type { MaskInputProps } from './MaskInput.types';
export type { Mask, MaskArray, MaskItem } from './formatWithMask.types';

export default MaskInput;
